import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';
import RemarksMgmt from './RemarksMgmt';

export default function UpdateRemarksActionImpl(){

    return (
        <RemarksMgmt/>
    )
}